import React from 'react'
import { Modal } from '@enamelai/design-system'
import './DeleteMembershipConfirmModal.css'

type DeleteMembershipConfirmModalProps = {
  open: boolean
  title: string
  message: string
  onClose: () => void
  onConfirm: () => void
}

const DeleteMembershipConfirmModal = ({
  open,
  title,
  message,
  onClose,
  onConfirm,
}: DeleteMembershipConfirmModalProps): React.ReactElement => (
  <Modal
    open={open}
    onClose={onClose}
    size="sm"
    title={title}
    className="membership-delete-confirm"
    bodyClassName="membership-delete-confirm__body"
    primaryLabel="Delete"
    primaryDestructive
    secondaryLabel="Cancel"
    onPrimaryClick={onConfirm}
    onSecondaryClick={onClose}
  >
    <p className="membership-delete-confirm__copy">{message}</p>
  </Modal>
)

export default DeleteMembershipConfirmModal
